module.exports = __webpack_public_path__ + "static/media/2-广联达智能物料验收系统.c20bf586.png";